import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import { showToast } from "../../redux/features/toast/toast.slice";
import { useDispatch } from "react-redux";
import PaidPlanIcon from "../../assets/PaidPlanIcon.svg";
import Navbar from "../home/components/Navbar";
import { clearAuthSession } from "../../utils/auth";

interface Product {
  id: string;
  name: string;
  currency: string;
  discount: string;
  price: number;
}

interface SubsciptionResponse {
  message: string;
  subscription_id: string;
  payment_link: string;
}

const Plans: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { state } = useLocation();
  let message = "none";
  if (state) message = state.message;
  if (message !== "none") {
    dispatch(showToast({ message: message, type: "error" }));
  }
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.clear();
    clearAuthSession();
    navigate("/"); // Redirect to the home page
  };

  const redirectToPlan = async (name: string, id: string) => {
    try {
      const url = `${process.env.REACT_APP_BASEURL}/users/dodopayments/create/`;
      const response = await axiosInstance.post<SubsciptionResponse>(url, {
        product_id: id,
      });
      console.log(response);
      localStorage.setItem("product_name_from_plans", name);
      window.location.href = response.data.payment_link;
    } catch (err: any) {
      if (err && err.response?.data) {
        dispatch(
          showToast({ message: err.response.data.message, type: "error" }),
        );
      }
    }
  };

  useEffect(() => {
    async function getProducts() {
      try {
        const url = `${process.env.REACT_APP_BASEURL}/users/dodopayments/products/`;
        const response = await axiosInstance.get<{ products: Product[] }>(url);
        setProducts(response.data.products);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      } finally {
        setLoading(false);
      }
    }

    getProducts();
    console.log(products);
  }, []); // runs once on mount

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Navbar />
      <div className="plans-page">
        {/* Header Section */}
        <div className="pricing-header">
          <div className="main-heading">
            <div className="main-header">
              <div className="pricing">Pricing</div>
            </div>
            <div>Plans</div>
          </div>

          <h2 className="sub-heading">Choose a plan that's right for you</h2>
          <button className="pricing-toggle">Monthly Pricing</button>
        </div>

        {/* Dynamic Plan Cards */}
        <div className="plans-container">
          {products.map((product) => (
            <div className="plan-card" key={product.id}>
              <div className="plan-icon">
                <img src={PaidPlanIcon} alt={`${product.name} icon`} />
              </div>

              <h2>{product.name}</h2>
              <p>
                {product.discount && Number(product.discount) > 0
                  ? `Save ${product.discount}% with this plan`
                  : "Enjoy our plan benefits."}
              </p>

              <div className="plan-price">
                {product.currency} {product.price} <span>per month</span>
              </div>

              <button
                className="plan-btn"
                onClick={() => redirectToPlan(product.name, product.id)}
              >
                Subscribe
              </button>
            </div>
          ))}
        </div>

        {/* Keep your styles here */}
        <style>{`
        .plans-page {
          background-color: #FBE5C6;
          font-family: 'Segoe UI', sans-serif;
          min-height: 100vh;
          text-align: center;
        }
        .pricing-header { overflow:hidden; }
        .main-heading {
          font-size: 4rem;
          font-weight: 700;
          color: #FF9A56;
          margin: 0;
          line-height: 1;
        }
        .main-header {
          display:flex;
          background-color:#FF9A56;
          width:100vw;
        }
        .pricing {
          display:flex;
          width:100vw;
          color: #FBE5C6;
          justify-content:center;
          background-color:#FF9A56;
        }
        .sub-heading {
          margin-top: 30px;
          font-size: 2.2rem;
          font-weight: 600;
        }
        .pricing-toggle {
          margin-top: 25px;
          padding: 12px 30px;
          border: 2px solid #FF9A56;
          border-radius: 30px;
          background: transparent;
          cursor: pointer;
          font-size: 1rem;
          font-weight: 500;
        }
        .plans-container {
          display: flex;
          justify-content: start;
          gap: 50px;
          padding: 60px 20px;
          padding-left:8vw;
          flex-wrap: wrap;
        }
        .plan-card {
          background-color: #FF9A56;
          color: #FBE5C6;
          width: 350px;
          border-radius: 20px;
          padding: 40px 30px;
          text-align: left;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          margin-top: 20px;
        }
        .plan-icon { text-align: center; margin-bottom: 20px; }
        .plan-icon img { width: 60px; height: 60px; }
        .plan-card h2 { margin: 0; font-size: 1.8rem; }
        .plan-card p { color: #caced6; margin: 8px 0 24px; }
        .plan-price { font-size: 2.3rem; font-weight: 700; margin-bottom: 30px; }
        .plan-price span { font-size: 0.9rem; opacity: 0.8; }
        .plan-btn {
          width: 100%;
          padding: 15px 0;
          background-color: #FBE5C6;
          color: #0d1337;
          border-radius: 10px;
          font-weight: 600;
          border: none;
          cursor: pointer;
        }
        @media(max-width: 768px) {
          .main-heading { font-size: 3rem; }
          .sub-heading { font-size: 1.6rem; }
          .pricing-toggle { padding: 10px 24px; font-size: 0.9rem; }
          .plan-card { width: 90%; }
        }
      `}</style>
      </div>
    </>
  );
};

export default Plans;
